import { IonButton, IonButtons, IonCol, IonContent, IonFooter, IonGrid, IonHeader, IonIcon, IonLabel, IonPage, IonRow, IonTitle, IonToolbar } from '@ionic/react';
import { arrowBackOutline, syncOutline } from 'ionicons/icons';
import React from 'react';

type Props = {
    totalCashBack: number;
    resgateCashBack?: number;
    items: any[];
    closeAction: Function;
    closeActionSimple: Function;
}

const Cashback: React.FC<Props> = (props: Props) => {

    function formatarData(isoDate: string): string {
        if (!isoDate) return "";
        const date = new Date(isoDate);
        return `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
    }

    return (
        <IonPage>
            <IonHeader className="ion-no-border">
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton onClick={() => props.closeActionSimple()}>
                            <IonIcon icon={arrowBackOutline} />
                        </IonButton>
                    </IonButtons>
                    <IonTitle>Meu Cashback</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent>
                <div style={{ padding: '20px', textAlign: 'center', background: 'var(--ion-color-light)', marginBottom: '10px' }}>
                    <IonLabel color="medium" style={{ fontSize: '14px', textTransform: 'uppercase', letterSpacing: '1px' }}>Saldo Disponível</IonLabel>
                    <h1 style={{ fontSize: '32px', fontWeight: '800', margin: '5px 0', color: 'var(--ion-color-success)' }}>
                        R$ {props.totalCashBack.toLocaleString('pt-br', { minimumFractionDigits: 2 })}
                    </h1>
                </div>

                <div style={{ padding: '0 10px' }}>
                    <IonLabel style={{ paddingLeft: '10px', fontWeight: 'bold' }}>Extrato Detalhado</IonLabel>

                    {props.items.length === 0 ? (
                        <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                            <IonIcon icon={syncOutline} style={{ fontSize: '48px', color: '#ccc' }} />
                            <p style={{ color: '#999' }}>Você ainda não possui cashback disponível nesta loja.</p>
                        </div>
                    ) : (
                        <IonGrid>
                            {props.items.map((item, index) => (
                                <IonRow key={index} style={{ borderBottom: '1px solid #f0f0f0', padding: '10px 0', alignItems: 'center' }}>
                                    {/* <IonCol size="2" sizeMd="1">
                                        <div style={{
                                            background: item.status === 'disponivel' ? 'rgba(45, 211, 111, 0.1)' : 'rgba(235, 68, 90, 0.1)',
                                            borderRadius: '50%',
                                            width: '40px',
                                            height: '40px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            <IonIcon icon={syncOutline} color={item.status === 'disponivel' ? "success" : "danger"} />
                                        </div>
                                    </IonCol> */}
                                    <IonCol size="9" sizeMd="10">
                                        <div style={{ fontWeight: 'bold', fontSize: '14px' }}>Compra no valor de R$ {item.valorPedido?.toLocaleString('pt-br', { minimumFractionDigits: 2 })}</div>
                                        <div style={{ fontSize: '11px', color: '#666', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                            {/* <IonIcon icon={calendarOutline} style={{ fontSize: '10px' }} /> */}
                                            {item.status === 'disponivel' ? 'Expira em: ' : 'Status: '} {item.status === 'disponivel' ? formatarData(item.dataExpiracao) : item.status.toUpperCase()}
                                        </div>
                                    </IonCol>
                                    <IonCol size="3" style={{ textAlign: 'right' }}>
                                        <div style={{ color: item.status === 'disponivel' ? 'var(--ion-color-success)' : 'var(--ion-color-danger)', fontWeight: 'bold' }}>
                                            {item.status === 'disponivel' ? '+' : ''} R$ {item.valorCashback?.toLocaleString('pt-br', { minimumFractionDigits: 2 })}
                                        </div>
                                        <div style={{ fontSize: '10px', color: '#999' }}>{item.percentualAplicado}% OFF</div>
                                    </IonCol>
                                </IonRow>
                            ))}
                        </IonGrid>
                    )}
                </div>
            </IonContent>

            <IonFooter className="ion-no-border">
                <IonToolbar style={{ padding: '10px' }}>
                    {(props.resgateCashBack && props.resgateCashBack > 0) ? (
                        <IonButton
                            expand="block"
                            onClick={() => props.closeAction(0)}
                            style={{ height: '50px', fontWeight: 'bold' }}
                        >
                            Remover Cashback
                        </IonButton>
                    ) : (
                        <IonButton
                            expand="block"
                            disabled={props.totalCashBack <= 0}
                            onClick={() => props.closeAction(props.totalCashBack)}
                            style={{ height: '50px', fontWeight: 'bold' }}
                        >
                            Utilizar Cashback
                        </IonButton>
                    )}
                </IonToolbar>
            </IonFooter>
        </IonPage>
    );
};

export default Cashback;
